import network from "../common/request";

const MaxRandomRange = 10000
// 获取markdown文本
export function getTextFromMdPath(path, callback) {
    fetch(path).then((response) => response.text()).then((text) => {
        callback(text)
    })
}

// 获取菜单
export function getMenu(text, haveDownload) {
    if (text === null || text.length === 0) { return [] }
    // 获取锚点
    let anchors = getAnchors(text)
    // 解析菜单
    const regXHeader = /(?<flag>#{1,6})\s+(?<content>.+)/g
    let titles = Array.from(text.matchAll(regXHeader)).map(({ groups: { flag, content } }) => ({
        heading: `h${ flag.length }`,
        content
    }))
    let treeData = []
    let treeDataLevel1 = []
    let treeDataLevel2 = []
    let index = 0
    let h2Key = ""
    let h3Key = ""

    titles.filter((title)=> {
        if (title.heading === "h2") {
            h2Key = "h2Key-dc" + Math.ceil(Math.random()*MaxRandomRange*index).toString()
            let itemH2 = itemParams(title.content, h2Key, (anchors.length > index) ? anchors[index]: "", [])
            treeData.push(itemH2)
        }
        if (title.heading === "h3") {
            h3Key = h2Key + "h3Key-dc" + Math.ceil(Math.random()*MaxRandomRange*index).toString()
            let itemH3= itemParams(title.content, h3Key, (anchors.length > index) ? anchors[index]: "",[])
            treeDataLevel1.push(itemH3)
        }
        if (title.heading === "h4") {
            let itemH4 = itemParams(title.content, h3Key + index.toString(),(anchors.length > index) ? anchors[index]: "", [])
            treeDataLevel2.push(itemH4)
        }
        index += 1
    })

    treeData.filter((data)=> {
        let children = []
        treeDataLevel1.filter((dataLevel1) => {
            let level1Children = []
            if (dataLevel1.key.includes(data.key)) {
                children.push(dataLevel1)
            }
            treeDataLevel2.filter((dataLevel2) => {
                if (dataLevel2.key.includes(dataLevel1.key)) {
                    level1Children.push(dataLevel2)
                }
                return true
            })
            dataLevel1.children = level1Children
            return true
        })
        data.children = children
        return true
    })
    return treeData
}

// 获取锚点
export function getAnchors(text) {
    let aReg = /<a\b[^>]+[^>]*>([\s\S]*?)<\/a>/g;
    let map = text.match(aReg);
    //匹配id
    let idReg = /id="([\s\S]*?)"/;
    let nameReg = /id="([\s\S]*?)"/;
    let ids = []
    if (map !== null) {
        map.filter((a)=> {
            let result = a.match(idReg)
            if (result !== null) {  ids.push(result[1])}
            return true
        })
        if (ids.length === 0) {
            ids = map ? map.map(a => {
                let result = a.match(nameReg)
                return result && result[1]
            }) : []
        }
    }
    return ids
}

// 菜单项
function itemParams(title, key, anchor, children) {
    return {title: title, href: "#"+anchor, key: key, children: children}
}

// 判断是否是移动端设备
export function isMobile() {
    const regex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
}
